import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, AlertCircle, CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AuthCardLayout } from '@/components/AuthCardLayout';
import { apiClient } from '@/lib/api-client';

export default function EsqueciSenha() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const res = await apiClient.post<{ message: string }>('/auth/esqueci-senha', { email });
      setMensagem(res.message || 'Se o e-mail estiver cadastrado, você receberá um link para redefinir a senha em instantes.');
      setEnviado(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao solicitar redefinição');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthCardLayout titulo="Esqueci minha senha" descricao="Informe seu e-mail e enviaremos um link para redefinir a senha">
      {enviado ? (
        <div className="space-y-4">
          <Alert className="animate-fade-in">
            <CheckCircle2 className="h-4 w-4" />
            <AlertDescription>{mensagem}</AlertDescription>
          </Alert>
          <Button asChild variant="outline" className="h-11 w-full">
            <Link to="/login">Voltar ao login</Link>
          </Button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <Alert variant="destructive" className="animate-fade-in">
              <AlertCircle className="h-4 w-4" />
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="h-11"
            />
          </div>
          <Button type="submit" className="h-11 w-full font-semibold" disabled={isLoading}>
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Enviando...
              </>
            ) : (
              'Enviar link por e-mail'
            )}
          </Button>
          <div className="text-center">
            <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground hover:underline">
              Voltar ao login
            </Link>
          </div>
        </form>
      )}
    </AuthCardLayout>
  );
}
